import { render, staticRenderFns } from "./NotAutorizatePage.vue?vue&type=template&id=186123ad"
import script from "./NotAutorizatePage.vue?vue&type=script&lang=js"
export * from "./NotAutorizatePage.vue?vue&type=script&lang=js"
import style0 from "./NotAutorizatePage.vue?vue&type=style&index=0&id=186123ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports